import { useDeprecationNotice } from "./DeprecationNoticeContext";
import { CautionIcon } from "./CautionIcon";
import "./DeprecationNotice.css";

// Lives in the header rather than floating over the page, so it can never sit
// on top of the Ops table's pagination or a popup's controls.
const DeprecationNoticeChip = () => {
  const notice = useDeprecationNotice();

  if (!notice || !notice.collapsed) return null;

  return (
    <button
      type="button"
      className="deprecation-chip"
      onClick={notice.expand}
      title="Service change 12 October — click for details"
      aria-label="Service change notice — expand"
    >
      <CautionIcon size={20} />
    </button>
  );
};

export default DeprecationNoticeChip;
